import { Window } from '@/components/base/Grid';
import LiquidGlass from '@/components/feature/LiquidGlass';

export default function Hero() {
  return (
    <section id="top" aria-labelledby="hero-title">
      <div
        className="mgrid !border-t-0 lg:grid-rows-[auto_1fr] lg:min-h-[max(640px,calc(100svh-64px))]"
      >
        {/* upper-left: statement */}
        <LiquidGlass className="lg:col-span-2 min-h-[380px]">
        <div className="cell h-full flex flex-col justify-between gap-12 min-h-[380px]">
          <div className="flex items-center justify-between t-label text-foreground-800 intro" style={{ animationDelay: '200ms' }}>
            <span className="veil flex items-center gap-2"><span className="w-1.5 h-1.5 bg-foreground-950" />Local SEO &amp; Digital Growth</span>
            <span className="veil hidden sm:inline">R / 00</span>
          </div>
          <div>
            <h1 id="hero-title" className="t-hero">
              <span className="block intro" style={{ animationDelay: '280ms' }}>Get found nearby.</span>
              <span className="block text-accent-600 intro" style={{ animationDelay: '380ms' }}>Get chosen next.</span>
            </h1>
            <div className="mt-8 lg:mt-10 flex flex-col sm:flex-row sm:items-end justify-between gap-6 intro" style={{ animationDelay: '520ms' }}>
              <p className="veil t-body text-foreground-900 max-w-[380px]">Search, maps and your website, working together at the moment nearby customers decide.</p>
              <a href="#contact" className="veil group inline-flex items-center gap-2 text-[15px] min-h-[44px] cursor-pointer whitespace-nowrap">
                <span className="uline pb-1">Book a consultation</span>
                <i className="ri-arrow-right-up-line arrow-nudge" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
        </LiquidGlass>

        {/* lower-left: field B (continuation) */}
        <Window className="half-l lg:order-1 h-[300px] md:h-[360px] lg:h-auto lg:min-h-[280px] border-t rule" tag="Fig. 01 — Local visibility field" />

        {/* lower-right: two quarters */}
        <div className="half-r lg:order-2 border-t rule grid grid-cols-1 sm:grid-cols-2">
          <div className="bg-accent-500 text-foreground-950 cell !py-8 lg:!py-10 flex flex-col justify-between gap-10 min-h-[240px] panel-in" style={{ animationDelay: '260ms' }}>
            <span className="t-label text-foreground-800">01 — Position</span>
            <div className="intro" style={{ animationDelay: '700ms' }}>
              <p className="font-heading text-[20px] lg:text-[23px] xl:text-[26px] leading-[1.14] tracking-[-0.02em]">We help ambitious local businesses get found, get chosen and grow.</p>
              <a href="#contact" className="group mt-5 inline-flex items-center gap-2 text-[15px] min-h-[44px] cursor-pointer whitespace-nowrap">
                <span className="border-b border-foreground-950 pb-0.5 group-hover:text-accent-900 group-hover:border-accent-900 transition-colors duration-200">Start a conversation</span>
                <i className="ri-arrow-right-up-line arrow-nudge" aria-hidden="true" />
              </a>
            </div>
          </div>
          <a href="#expertise" className="group bg-primary-500 text-background-50 cell !py-8 lg:!py-10 flex flex-col justify-between gap-8 min-h-[200px] sm:min-h-[240px] cursor-pointer hover:bg-primary-600 transition-colors duration-300 panel-in" style={{ animationDelay: '340ms' }}>
            <ul className="flex flex-col gap-1.5">
              {['Search', 'Maps', 'Enquiries'].map((t, i) => (
                <li key={t} className="t-label flex gap-3"><span className="text-accent-400">0{i + 1}</span>{t}</li>
              ))}
            </ul>
            <div className="flex items-end justify-between gap-4">
              <p className="font-heading text-[19px] lg:text-[21px] leading-tight tracking-[-0.02em] max-w-[200px]">Visibility that turns into action.</p>
              <span className="w-9 h-9 shrink-0 border border-background-50 rounded-full flex items-center justify-center"><i className="ri-arrow-right-down-line arrow-nudge" /></span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}